import moment from 'moment'
import { Lang } from '../translations/lang'

export function toFormattedDatetime(dateTime: string | undefined): string {
  return dateTime ? moment(dateTime).format(Lang.dateTimeFormat) : ''
}
